import CompanyId from 'models/Profile/CompanyId';
import CompanyGroup from 'models/Profile/CompanyGroups';
import Product from 'models/Profile/Product';

type Company = {
  name: string,
  identifier: string,
  pending: boolean,
  appended?: boolean,
  products: Array<Product>,
  groups: Array<CompanyGroup>,
  companyId: Array<CompanyId>
}

function addCompaniesToCompanyGroup(companiesGroup : Array<CompanyGroup>, companies : Array<Company>) : Array<CompanyGroup> {
  companiesGroup.forEach((group) => {
    companies.forEach((company) => {
      if(company.appended)
        return;

      if(isGroupEmpty(company))
        return;

      const productsGroup = company.groups.filter((x) => x.productName === group.productName);
      if(!hasCurrentProduct(productsGroup))
        return;

      const product = productsGroup.filter((x) => x.groupId === group.groupId && x.groupName === group.groupName);
      if(!hasCurrentGroup(product))
        return;

      company.appended = true;
      appendCompany(group, company);
    });
  });

  const ungroupedCompanies = companies.filter(x => !x.appended);

  if(ungroupedCompanies.length > 0)
    companiesGroup.push({companies : ungroupedCompanies} as unknown as CompanyGroup);

  return companiesGroup;
}

const isGroupEmpty = (company : Company) : boolean => !company.groups;

const hasCurrentProduct = (productsGroup : Array<CompanyGroup>) : boolean => productsGroup.length > 0;

const hasCurrentGroup = (productsGroup : Array<CompanyGroup>) : boolean => productsGroup.length > 0;

function appendCompany(companyGroup : CompanyGroup, company : Company) : void {
  if(!companyGroup.companies)
    companyGroup.companies = [];

  companyGroup.companies.push({ name: company.name, identifier: company.identifier, products : company.products, companyId : company.companyId, pending : company.pending });
}

export default addCompaniesToCompanyGroup;